<template>
  <header class="home">
    <div class="header_nav">
      <h1 class="logo">
        <img src="../../assets/logo_mai_large.svg" alt="100mai" />
      </h1>
      <nav>
        <ul>
          <li>
            <a href="/home" v-bind:class="{ current: $route.name == 'Home' }"
              ><i class="fas fa-home"></i>
              <p>ホーム</p>
            </a>
          </li>
          <li>
            <a
              href="/ranking"
              v-bind:class="{ current: $route.name == 'Ranking' }"
              ><i class="fas fa-rocket"></i>
              <p>応援</p>
            </a>
          </li>
          <li>
            <a
              href="/setting"
              v-bind:class="{ current: $route.name == 'Setting' }"
              ><i class="fas fa-cog"></i>
              <p>設定</p>
            </a>
          </li>
        </ul>
      </nav>
    </div>
    <div
      class="header_status"
      v-if="!loading"
      v-bind:class="{ logout: !login ? true : false }"
    >
      <img
        class="logo"
        v-if="!login"
        src="./../../assets/logo_mai_large.svg"
        alt="100mai"
      />
      <button
        class="return"
        v-if="
          $route.name == ':userId' ||
          $route.name == 'New' ||
          $route.name == 'Challenge'
        "
        @click="$router.go(-1)"
      >
        <i class="fas fa-arrow-left"></i>
      </button>
      <div class="flex" v-if="login">
        <a href="" class="status_user">
          <p class="user_icon"><img :src="profile.icon" /></p>
          <p class="user_name">{{ profile.name }}</p>
          <p class="user_status" v-bind:class="{ active: profile.challenge }">
            ◎チャレンジ中
          </p>
        </a>
        <MaiPopup v-bind:mai="mai" />
      </div>
      <LoginPopup v-else />
      <Notice v-if="login" v-bind:notice="notice" />
    </div>
    <div class="user_profile" v-if="$route.name == ':userId'">
      <div class="icon">
        <p class="user_icon"><img :src="profile.icon" /></p>
      </div>
      <div class="content">
        <p class="user_name">{{ profile.name }}</p>
        <p class="user_status" v-bind:class="{ active: profile.challenge }">
          ◎チャレンジ中
        </p>
        <div class="status_mai">
          <div class="mai">
            <p class="mai_given">
              <span>貰ったmai</span><span>{{ mai.given }}</span>
            </p>
            <p class="mai_send">
              <span>贈ったmai</span><span>{{ mai.send }}</span>
            </p>
          </div>
          <div class="link">
            <a class="link_HP"><i class="fas fa-shoe-prints"></i></a>
            <a class="link_twitter active"><i class="fab fa-twitter"></i></a>
          </div>
          <!-- v-ifでhref&active付与 -->
        </div>
        <div class="status_profile">
          <!-- v-ifでプロフィールがある場合のみ表示 -->
          <p class="text">
            プロフィール
            <textarea
              class="active"
              maxlength="200"
              @input="saveBtn = true"
              v-model="profile.textarea"
              disabled
            ></textarea>
            <!-- v-ifでuserIDが一致するときのみ編集可能.active付与 -->
          </p>
          <!-- <div class="save_btn" v-if="saveBtn">
            <button @click="saveBtn = !saveBtn">保存する</button>
          </div> -->
          <!-- textareaが入力を受け取ったら表示する -->
          <!-- ボタンが押されたら再び入力を受け取るまで消す -->
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import MaiPopup from "@/components/parts/MaiPopup";
import LoginPopup from "@/components/parts/LoginPopup";
import Notice from "@/components/parts/Notice";
import firebaseUtil from "@/firebase";
import store from "@/store";

// https://qiita.com/kawakami-kazuyoshi/items/ec6f264209df2e8d47ac
export default {
  components: {
    MaiPopup,
    LoginPopup,
    Notice,
  },
  props: ["pageName", "login", "profile", "mai", "loading"],
  data() {
    return {
      saveBtn: false,
      notice: {},
    };
  },
  mounted() {
    document.title = `${this.pageName} | 100mai`;
  },
  computed: {
    loginWatch() {
      return this.login;
    },
  },
  watch: {
    loginWatch(data) {
      if (data) {
        if (!store.getters.user_profile.state) {
          let myPromise1 = new Promise((resolve) => {
            firebaseUtil.getUserProfile(store.getters.user.uid).then(() => {
              resolve();
            });
          });
          myPromise1.then(() => {
            this.$emit("profile", store.getters.user_profile);
          });
        } else {
          this.$emit("profile", store.getters.user_profile);
        }
        if (!store.getters.mai.state) {
          let myPromise1 = new Promise((resolve) => {
            firebaseUtil.getMai(store.getters.user.uid).then(() => {
              resolve();
            });
          });
          myPromise1.then(() => {
            this.$emit("mai", store.getters.mai);
          });
        } else {
          this.$emit("mai", store.getters.mai);
        }
        if (!store.getters.notice.state) {
          let myPromise1 = new Promise((resolve) => {
            firebaseUtil.getNotice(store.getters.user.uid).then(() => {
              resolve();
            });
          });
          myPromise1.then(() => {
            this.notice = store.getters.notice;
          });
        }
      }
    },
  },
};
</script>

<style lang="scss">
/* header */
header {
  margin: 0 auto;
  position: relative;
  @include sp() {
    padding: 0;
  }
  .logo {
    @include flex_c();
    width: 120px;
  }
}

/* header_nav */
.header_nav {
  padding: 0 4.6vw;
  height: $height_ss;
  display: flex;
  justify-content: space-between;
  background: $bg_base;
  box-shadow: $btn_shadow;
  @include zIndex(100);
  ul {
    display: flex;
    align-items: center;
    height: 100%;
  }
  li {
    &:last-child a::after {
      content: none;
    }
  }
  a {
    padding: 0 14px 0 10px;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
    height: 100%;
    position: relative;
    &::after {
      @include pseudo(60%, 100%);
      top: 20%;
      left: 0;
      border-right: 1px solid $text_black;
      transform: skewX(160deg);
    }
    &.current {
      p,
      i {
        color: $main_orange;
      }
    }
  }
  p {
    margin: 0 6px 0 10px;
    font-weight: 500;
  }
  @include sp() {
    display: block;
    position: fixed;
    width: 100%;
    height: $height_ss + 20px;
    bottom: 0;
    left: 0;

    .logo {
      display: none;
    }

    ul {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
    }

    li {
      margin: 10px 0 0;
    }

    a {
      flex-direction: column;
    }

    p {
      font-size: 14px;
      margin: 0;
    }
  }
  @include pc() {
    a {
      border-radius: 20px;
      height: 40px;
      padding: 0 10px;
      min-width: 110px;
      i,
      p {
        transition: 0.3s;
      }
      &:hover {
        p {
          color: $main_orange;
        }
        i {
          transform: translateY(-2px);
          color: $main_orange;
        }
      }
    }
  }
}

/* header_status */
.header_status {
  padding: 0 4.6vw;
  height: $height_s;
  display: flex;
  align-items: center;
  justify-content: right;
  position: relative;
  &.logout {
    justify-content: space-between;
  }
  .return {
    position: absolute;
    left: 10px;
  }
  .logo {
    padding: 10px;
    max-width: 160px;
    background-color: #fff;
  }
  .flex {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: right;
    margin-left: auto;
    margin-right: 10px;
  }
  .status_user {
    margin-left: 20px;
    display: grid;
    align-items: center;
    grid-template-columns: auto 1fr;
    grid-template-areas:
      "a b"
      "a c";
    .user {
      &_icon {
        grid-area: a;
        @include icon(40px);
        border: 2px solid $bg_accent;
        background-color: #fff;
        margin-right: 4px;
      }
      &_name {
        grid-area: b;
        @include fz(16);
        align-self: end;
        @include text_overflow(1);
      }
      &_status {
        grid-area: c;
        @include fz(12);
        align-self: start;
        white-space: nowrap;
      }
    }
  }
  .status_mai {
    margin-left: 10px;
    &_btn {
      width: 100%;
      height: 40px;
      display: grid;
      grid-template-columns: auto 1fr auto;
      align-items: center;
      grid-column-gap: 4px;
      padding: 6px 10px;
      border-radius: 20px;
      position: relative;
      box-shadow: 0px 0px 8px #dddddddd;
      &:after {
        @include pseudo(100%, 100%);
        top: 0;
        left: 0;
        border-radius: 20px;
        opacity: 0;
        transition: 0.3s ease-out;
        background-color: $main_orange;
      }
      .mai_icon {
        @include icon(30px);
        i {
          @include fz(24);
          color: $main_orange;
        }
      }
      .mai_counter {
        font-weight: 500;
        @include fz(20);
        @include text_overflow(1);
      }
      .mai_current {
        @include fz(16);
      }
    }
    @include pc {
      &_btn {
        &:hover {
          &:after {
            opacity: 1;
            @include zIndex(-1);
          }
          color: #fff;
          i {
            color: #fff;
            animation: shake 0.5s normal;
          }
        }
      }
    }
  }
  .status_notice {
    &_btn {
      @include icon(40px);
      i {
        @include fz(20);
      }
      @include default_button("shake");
    }
  }
  @include sp {
    .status_user {
      grid-gap: 0;
    }
    .status_mai_btn {
      display: block;
      padding: 0;
      .mai_counter,
      .mai_current {
        display: none;
      }
      .mai_icon {
        @include icon(40px);
        border: 2px solid $main_orange;
        i {
          @include fz(20);
        }
      }
    }
  }
}

/* user_profile */
.user_profile {
  margin-top: 20px;
  .icon {
    padding: 20px 0;
    display: flex;
    flex-direction: column;
    box-shadow: inset 0px 0px 8px #dddddddd;
    border-top-left-radius: 50%;
    border-top-right-radius: 50%;
    position: relative;
    // background-color: $bg_base;
    &::after {
      @include pseudo(20px, 100vw);
      background: $bg_gradient;
      bottom: 0;
      left: 0;
    }
    .user_icon {
      @include icon(80px);
      border: 2px solid $bg_accent;
      background-color: #fff;
      margin: 0 auto;
    }
  }
  .content {
    padding: 0px 4.6vw 40px;
    .user_name,
    .user_status {
      text-align: center;
    }
    .user_name {
      font-weight: 500;
    }
    .user_status {
      @include fz(14);
    }
    .status_mai {
      padding: 10px 0;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      .mai {
        margin: 10px 0;
        display: flex;
        &_send,
        &_given {
          @include fz(16);
          margin-right: 20px;
          display: flex;
          flex-direction: column;
          align-items: center;
          span:first-child {
            border-bottom: 2px solid $main_orange;
          }
          span:last-child {
            font-weight: 500;
          }
        }
      }
      .link {
        margin: 10px 0;
        margin-left: auto;
        display: flex;
        &_HP,
        &_twitter {
          margin-left: 10px;
          @include icon(40px);
          border: 2px solid $bg_accent;
          i {
            color: $bg_accent;
          }
        }
        &_HP {
          i {
            @include fz(18);
          }
        }
        &_HP.active,
        &_twitter.active {
          @include default_button("shake");
        }
      }
    }
    .status_profile {
      margin-top: 20px;
      textarea {
        margin-top: 10px;
        width: 100%;
        min-height: 120px;
        resize: none;
        @include fz(16);
        line-height: 1.5em;
        background-color: $bg_base;
        &.active {
          padding: 8px;
          border-radius: 4px;
          box-shadow: inset $btn_shadow;
          &:focus {
            // resize: vertical;
          }
        }
      }
      .save_btn {
        position: relative;
        button {
          margin: 0 auto;
          @include text_btn($main_orange);
        }
      }
    }
  }
  @include sp {
    .icon {
      .user_icon {
        @include icon(60px);
      }
    }
  }
}
</style>
